export default "__VITE_ASSET__DjMJzFdB__"